export default __webpack_public_path__ + "static/media/logo3.2a6f5334.svg";